import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { motion } from 'framer-motion';
import { sizes, mediaBreakpointUp } from 'conversional-theme';
import { generateClasses } from 'conversional-components';
import { JourneysSelectors, useAppSelector } from 'conversional-journey';
var container = {
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.8,
        },
    },
    hidden: {
        opacity: 0,
    },
};
var item = {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
};
var ResultComponent = function (props) {
    var _a = React.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    React.useEffect(function () {
        var timer = setTimeout(function () { return setIsOpen(!isOpen); }, 1000);
        return function () { return clearTimeout(timer); };
    }, []);
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var children = props.children;
    var styles = generateClasses(Styles)(theme);
    return (_jsx(motion.div, { initial: "hidden", animate: isOpen ? 'show' : 'hidden', variants: container, className: styles.frame, children: React.Children.map(children, function (child, i) {
            return (_jsx(motion.div, { variants: item, children: child }, "".concat(child === null || child === void 0 ? void 0 : child.key, ".").concat(i)));
        }) }));
};
var Styles = function (theme) {
    var _a;
    return ({
        frame: (_a = {
                position: 'relative',
                fontFamily: "".concat(theme.typo.fonts.regular, " !important"),
                paddingBottom: theme.spaces.desktop.l
            },
            _a[mediaBreakpointUp(sizes.md)] = {
                marginLeft: theme.spaces.desktop.mL,
                marginRight: theme.spaces.desktop.mL,
            },
            _a),
    });
};
export default ResultComponent;
